import React from "react";

function Footer() {
    return <div>
        <footer>
            <p className='foot'>Made with ❤️ by Archit Rathod</p>
        </footer>
    </div>;
}

export default Footer;
